// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Vuetify from "vuetify";
import VueResource from "vue-resource";
import VueClipboard from "vue-clipboard2";
import App from "./App";
import router from "./router";
import { requestProcessing } from "./interceptors";
import AuthService from "./auth/AuthService";

import "babel-polyfill";
import "vuetify/dist/vuetify.min.css"; // Ensure you are using css-loader
import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure you are using css-loader
import colors from "vuetify/es5/util/colors";

if (process.env.VUE_APP_ENABLE_LOGROCKET) {
  import("logrocket").then(module => {
    const LogRocket = module.default;
    LogRocket.init("c9tql3/prototype");
    const auth = new AuthService();
    const token = auth.getAccessToken();
    auth.getUserInfo(token).then(userInfo => {
      LogRocket.identify(userInfo.email, {
        name: userInfo.name
      });
    });
  });
}

Vue.config.productionTip = false;

Vue.use(Vuetify, {
  theme: {
    primary: colors.red.darken1, // #E53935
    secondary: colors.red.lighten4, // #FFCDD2
    accent: colors.indigo.base // #3F51B5
  }
});

Vue.use(VueClipboard);
Vue.use(VueResource);

// Global interceptor, authorizes all outbound requests.
Vue.http.interceptors.push(requestProcessing);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  render: h => h(App)
});
